export enum LoyaltyTutorialSteps {
  CLOSED = -1,
  CHECK_CURRENT_STATUS = 0,
  HOW_TO_EARN_POINTS = 1,
  VIP_CLUB_BENEFITS = 2,
}

export const ANIMATION_DELAY = 140;
